import React from "react";
import { Textarea as BaseTextarea, TextareaProps as BaseTextareaProps } from "baseui/textarea";
import { Overrides } from "baseui/overrides";
import { mergeOverrides } from "baseui";
import { StyledCharacterCounter } from "../shared/shared_styles";
export * from "baseui/textarea";

const getTextAreaOverrides = (dataTest: string) => {
  return {
    Root: {
      style: ({ $theme, $isFocused, $disabled, $error, $positive }) => {
        if (!$error && !$positive) {
          return {
            ...(!$isFocused && {
              borderTopColor: $theme.colors.mono600,
              borderBottomColor: $theme.colors.mono600,
              borderLeftColor: $theme.colors.mono600,
              borderRightColor: $theme.colors.mono600,
            }),
            ...($disabled && {
              borderTopColor: $theme.colors.mono400,
              borderBottomColor: $theme.colors.mono400,
              borderLeftColor: $theme.colors.mono400,
              borderRightColor: $theme.colors.mono400,
            }),
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
          };
        }
        return {
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        };
      },
    },
    InputContainer: {
      style: ({ $theme, $error, $positive }) => {
        if (!$error && !$positive) {
          return {
            backgroundColor: $theme.colors.backgroundAlwaysLight,
          };
        }
      },
    },
    Input: {
      props: {
        "data-test": dataTest,
      },
    },
  } as Overrides<
    BaseTextarea & { $isFocused: boolean; $disabled: boolean; $error: boolean; $positive: boolean }
  >;
};

export interface TextareaProps extends BaseTextareaProps {
  currentCharacterCount?: number;
  maxCharacterCount?: number;
  dataTest?: string;
}

const Textarea = ({
  dataTest = "textarea",
  currentCharacterCount = 0,
  maxCharacterCount,
  ...props
}: TextareaProps) => {
  const mergedOverrides = mergeOverrides(
    getTextAreaOverrides(dataTest),
    props.overrides as Overrides<
      BaseTextarea & {
        $isFocused: boolean;
        $disabled: boolean;
        $error: boolean;
        $positive: boolean;
      }
    >
  );
  return (
    <>
      {maxCharacterCount && (
        <StyledCharacterCounter $danger={currentCharacterCount > maxCharacterCount}>
          {currentCharacterCount}
          {maxCharacterCount ? ` / ${maxCharacterCount}` : ""}
        </StyledCharacterCounter>
      )}
      <BaseTextarea {...props} overrides={mergedOverrides} />
    </>
  );
};

export default Textarea;
